<template>
  <v-sheet class="pa-3">
     <v-sheet class="text-right">
      <v-btn
        icon
        color="error"
        @click="$router.go('-1')"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </v-sheet>
      

    <FormEncabezado :data="item" />
    <v-divider></v-divider>
    <TableProductos :data="productos" :totales="item"/>
  </v-sheet>
</template>

<script>
import {mapGetters} from'vuex'
import currency from "@/utils/currency.js";
import axios from 'axios'
import FormEncabezado from './MostrarComprobante/FormEncabezado.vue'
import TableProductos from './MostrarComprobante/TableProductos.vue'

export default {

  components:{
    FormEncabezado,
    TableProductos
  },
  data () {
    return{
      item:{},
      productos:{}
    }
  },
  computed:{
    ...mapGetters(["getCompraById",'getTokenUser','getUrlApi'])
  },
  async created(){
    this.main()
    await this.getFacturaDetalle()
  },
  methods: {
    main(){
      const id = this.$route.params.id
      this.item =  this.getCompraById(id)
  
    },
    async getFacturaDetalle(){
      const id = this.$route.params.id
      const { data } = await axios.get(`${this.getUrlApi}/facturadetalles/${id}`,this.getTokenUser);
      this.productos = data
      this.sumarDescuento()
    },
    sumarDescuento(){
       const sumatoria = this.productos.reduce( (valorAnterior, valorActual) => {
                                                  return  valorAnterior + parseFloat(valorActual.descuento)
                                                  }, 0
                                                )
       this.item.descuento = currency(sumatoria, { precision: 2 });
    }
  }
  
}
</script>
<style scoped>
.main{
  margin-top:-10px;
  height: 100vh;
}
</style>